<div class="modal-header modal-block-primary">
  <button type="button" class="close" (click)="modalRef.hide()">
    <span aria-hidden="true">&times;</span>
    <span class="sr-only">Close</span>
  </button>
  <h4 class="modal-title">Delete</h4>
</div>
<div class="modal-body">
  <div class="row">
    <div class="col-md-12">
      <input
        maxlength="1024"
        type="text"
        class="form-control"
        [(ngModel)]="deleteReason"
        name="claimDeleteReasonInput"
        placeholder="Provide reason to delete"
      />
    </div>
  </div>
</div>
<div class="modal-footer">
  <button
    type="button"
    class="btn btn-primary"
    (click)="claimDeleteSubmit($event)"
    [disabled]="deleteReason === ''"
  >
    OK
  </button>
  <button type="button" class="btn btn-default" data-dismiss="modal" (click)="modalRef.hide()">
    Cancel
  </button>
</div>
